/* eslint-disable import/prefer-default-export */
import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Assumptions",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.assumptions.header"
      }
    ]
  },
  assumable: {
    label: "Assumable",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Is this loan Assumable?",
        style: { marginRight: "50%" }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "details.assumable",
        variant: "filled",
        hideLabel: true,
        label: "Yes",
        altlabel: "No"
      }
    ]
  },
  transferFee: {
    label: "Transfer Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "details.transferFee",
        variant: "filled"
      }
    ]
  },
  conditionsToTransfer: {
    label: "Conditions to Transfer",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "details.conditionsToTransfer",
        variant: "filled",
        multiline: true
      }
    ]
  }
};
